"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = toArray;
exports.getEnv = getEnv;
exports.eachWithIndex = eachWithIndex;
function toArray(obj) {
  return Array.prototype.splice.call(obj, 0);
}

function getEnv() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") {
    return "browser";
  } else {
    return "nodejs";
  }
}

function eachWithIndex(arr, iter) {
  if (!(arr instanceof Array)) {
    return;
  }
  if (typeof iter !== "function") {
    return;
  }
  for (var i = 0; i < arr.length; i++) {
    iter(i, arr[i]);
  }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy91dGlsLmVzNiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7OztRQUVnQjtRQUlBO1FBU0E7QUFiVCxTQUFTLE9BQVQsQ0FBaUIsR0FBakIsRUFBcUI7QUFDMUIsU0FBTyxNQUFNLFNBQU4sQ0FBZ0IsTUFBaEIsQ0FBdUIsSUFBdkIsQ0FBNEIsR0FBNUIsRUFBaUMsQ0FBakMsQ0FBUCxDQUQwQjtDQUFyQjs7QUFJQSxTQUFTLE1BQVQsR0FBaUI7QUFDdEIsTUFBRyxRQUFPLHVEQUFQLEtBQWtCLFFBQWxCLEVBQTJCO0FBQzVCLFdBQU8sU0FBUCxDQUQ0QjtHQUE5QixNQUdJO0FBQ0YsV0FBTyxRQUFQLENBREU7R0FISjtDQURLOztBQVNBLFNBQVMsYUFBVCxDQUF1QixHQUF2QixFQUE0QixJQUE1QixFQUFpQztBQUN0QyxNQUFHLEVBQUUsZUFBZSxLQUFmLENBQUYsRUFBd0I7QUFBRSxXQUFGO0dBQTNCO0FBQ0EsTUFBRyxPQUFPLElBQVAsS0FBZ0IsVUFBaEIsRUFBMkI7QUFBRSxXQUFGO0dBQTlCO0FBQ0EsT0FBSSxJQUFJLElBQUksQ0FBSixFQUFPLElBQUksSUFBSSxNQUFKLEVBQVksR0FBL0IsRUFBbUM7QUFDakMsU0FBSyxDQUFMLEVBQVEsSUFBSSxDQUFKLENBQVIsRUFEaUM7R0FBbkM7Q0FISyIsImZpbGUiOiJ1dGlsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiXCJ1c2Ugc3RyaWN0XCI7XG5cbmV4cG9ydCBmdW5jdGlvbiB0b0FycmF5KG9iail7XG4gIHJldHVybiBBcnJheS5wcm90b3R5cGUuc3BsaWNlLmNhbGwob2JqLCAwKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldEVudigpe1xuICBpZih0eXBlb2Ygd2luZG93ID09PSBcIm9iamVjdFwiKXtcbiAgICByZXR1cm4gXCJicm93c2VyXCI7XG4gIH1cbiAgZWxzZXtcbiAgICByZXR1cm4gXCJub2RlanNcIjtcbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24gZWFjaFdpdGhJbmRleChhcnIsIGl0ZXIpe1xuICBpZighKGFyciBpbnN0YW5jZW9mIEFycmF5KSl7IHJldHVybjsgfVxuICBpZih0eXBlb2YgaXRlciAhPT0gXCJmdW5jdGlvblwiKXsgcmV0dXJuOyB9XG4gIGZvcihsZXQgaSA9IDA7IGkgPCBhcnIubGVuZ3RoOyBpKyspe1xuICAgIGl0ZXIoaSwgYXJyW2ldKTtcbiAgfVxufVxuIl19


/*****************
 ** WEBPACK FOOTER
 ** ./~/korg-nano-kontrol/lib/util.js
 ** module id = 8
 ** module chunks = 2
 **/